// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"712fce9e","387":"6ede20cf","496":"0546cb33","915":"83d47eff"}[chunkId] + ".chunk.js";
};